<template>
  <div class="card-coll" data-aos="fade-up" data-aos-duration="900">
    <div class="card-coll-img-wrapper zoom-img-container" @click="goToCollection(getCollectionUrl())">
      <img :src="collection.image || collection.photo_key || 'https://hortense-vue.s3.eu-west-3.amazonaws.com/static/default.jpg'" :alt="collection.title || collection.name" class="card-coll-img zoom-img" />
      <div class="card-coll-title-overlay">
        <span class="card-coll-title merriweather-light-italic-24">{{ collection.name }}</span>
      </div>
    </div>
    <div class="card-coll-content text-center mt-2">
      <div class="card-coll-type raleway-semi-p16 mb-1">{{ collection.title }}</div>
      <a :href="getCollectionUrl()" class="card-coll-link raleway-reg-p15">Découvrir la collection</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardColl",
  props: {
    collection: { type: Object, required: true },
  },
  methods: {
    getCollectionUrl() {
      const slug = this.collection.slug;
      if (slug && slug.startsWith('vacances-')) {
        return '/' + slug;
      }
      return '/collections/' + slug;
    },
    goToCollection(url) {
      window.open(url, '_blank');
    },
  },
};
</script>

<style scoped lang="scss">
.card-coll {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
}
.card-coll-img-wrapper {
  position: relative;
  width: 420px;
  height: 220px;
  overflow: hidden;
  border-radius: 0;
  cursor: pointer;
}
.card-coll-img {
  width: 420px;
  height: 220px;
  object-fit: cover;
  display: block;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 40.38%, rgba(0, 0, 0, 0.8) 100%);
}
.card-coll-title-overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 18px;
  text-align: center;
  pointer-events: none;
}
.card-coll-title {
  color: #F7F7F7;
}
.card-coll-content {
  margin-top: 18px;
}
.card-coll-type {
  text-transform: uppercase;
  color: #222;
}
.card-coll-link {
  color: #000000;
  text-decoration: underline;
  transition: color 0.2s;
}
.card-coll-link:hover {
  font-weight: 400;
}
@media (max-width: 900px) {
  .card-coll {
    max-width: 100%;
    padding: 0 4% 0 4%;
  }
  .card-coll-img-wrapper {
    height: 220px;
    width: 100%;
  }
  .card-coll-img {
    height: 220px;
    width: 100%;
  }
}
</style>
